export enum FeatureFlagEnum {
  IS_BETA_STORE = 'is_beta_store',
  IKB2C_4165_ENABLE_CIN = 'ikb2c_4165_enable_cin',
  IKB2C_4165_ENABLE_RG_DIGITAL = 'ikb2c_4165_enable_rg_digital',
  IKB2C_4132_ENABLE_EXTERNAL_LINK = 'ikb2c_4132_enable_external_link',
  IKB2C_3936_SMARTPHONE_CATALOG_POPULATION = 'ikb2c_3936_smartphone_catalog_population',
  IKB2C_4429_ENABLE_SELLER_FEATURE = 'ikb2c_4429_enable_seller_feature',
  IKB2C_4692_STORE_GROUPS_IMPROVEMENT = 'ikb2c_4692_store_groups_improvement',
  IKCLOUD_3074_IMPLEMENT_MAXIMUM_VALUES = 'ikcloud_3074_implement_maximum_values',
  IKLOUD_6002_ENABLE_PRE_CONTRACT_AFTER_TOKEN_VALIDATION = 'ikcloud_6002_pre_contract_after_token_validation',
  IKCLOUD_12852_SELLER_BANK_ACCOUNT_BACKOFFICE = 'ikcloud_12852_seller_bank_account_backoffice',
  IKCLOUD_12852_SELLER_BANK_ACCOUNT_PHYSICAL = 'ikcloud_12852_seller_bank_account_physical',
  IKCLOUD_7329_DASHBOARD_HOMEPAGE = 'ikcloud_7329_dashboard_homepage',
  IKB2C_10334_EXPORT_ALL_CONTRACT_LIST = 'ikcloud_10334_export_all_contract_list',
  IKCLOUD_33367_ENABLE_PIX_PAYMENT = 'ikcloud_33367_enable_pix_payment',
  IKCLOUD_50567_REMOVE_EAN = 'ikcloud_50567_remove_ean',
  IKCLOUD_22142_RANKING_SELLER_DOWNLOAD = 'ikcloud_22142_ranking_seller_download',
  IKCLOUD_78260_SELLER_FILE_UPLOAD_FEATURE = 'ikcloud_78260_seller_file_upload_feature',
}
